import { writable } from "svelte/store";

export let userTableFilter = writable(null);